// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import ModelSearchGroup from "./model-search-group.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "is_collection": {
      "column": null,
      "name": "is_collection",
      "selected_by_default": null,
      "translated": null
    },
    "model_search_group_id": {
      "column": {
        "default": null,
        "name": "model_search_group_id",
        "null": false,
        "type": "uuid"
      },
      "name": "model_search_group_id",
      "selected_by_default": null,
      "translated": null
    },
    "relationship_path": {
      "column": {
        "default": null,
        "name": "relationship_path",
        "null": true,
        "type": "text"
      },
      "name": "relationship_path",
      "selected_by_default": null,
      "translated": null
    },
    "relationship_path_with_labels": {
      "column": null,
      "name": "relationship_path_with_labels",
      "selected_by_default": null,
      "translated": null
    },
    "rule_attribute": {
      "column": {
        "default": null,
        "name": "rule_attribute",
        "null": false,
        "type": "string"
      },
      "name": "rule_attribute",
      "selected_by_default": null,
      "translated": null
    },
    "rule_attribute_data": {
      "column": null,
      "name": "rule_attribute_data",
      "selected_by_default": null,
      "translated": null
    },
    "search_matcher": {
      "column": {
        "default": null,
        "name": "search_matcher",
        "null": false,
        "type": "string"
      },
      "name": "search_matcher",
      "selected_by_default": null,
      "translated": null
    },
    "search_value": {
      "column": {
        "default": null,
        "name": "search_value",
        "null": true,
        "type": "jsonb"
      },
      "name": "search_value",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ModelSearchRule",
  "collectionKey": "model_search_rules",
  "collectionName": "model_search_rules",
  "i18nKey": "model_search_rule",
  "camelizedLower": "modelSearchRule",
  "name": "ModelSearchRule",
  "nameDasherized": "model-search-rule",
  "pluralName": "model_search_rules",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "ModelSearch",
      "collectionName": "model_searches",
      "foreignKey": "model_search_id",
      "name": "model_search",
      "macro": "has_one",
      "resource_name": "ModelSearch",
      "through": "model_search_group"
    },
    {
      "className": "ModelSearchGroup",
      "collectionName": "model_search_groups",
      "foreignKey": "model_search_group_id",
      "name": "model_search_group",
      "macro": "belongs_to",
      "resource_name": "ModelSearchGroup",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "collection",
      "column": {
        "default": false,
        "name": "collection",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "model_search_group_id",
      "column": {
        "default": null,
        "name": "model_search_group_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_model_search_group_id",
      "column": {
        "default": null,
        "name": "old_model_search_group_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "relationship_path",
      "column": {
        "default": null,
        "name": "relationship_path",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "rule_attribute",
      "column": {
        "default": null,
        "name": "rule_attribute",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "search_matcher",
      "column": {
        "default": null,
        "name": "search_matcher",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "search_value",
      "column": {
        "default": null,
        "name": "search_value",
        "null": true,
        "type": "jsonb"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ModelSearchGroup",
      "collectionName": "model_search_groups",
      "foreignKey": "model_search_group_id",
      "name": "model_search_group",
      "macro": "belongs_to",
      "resource_name": "ModelSearchGroup",
      "through": null
    }
  ],
  "paramKey": "model_search_rule",
  "primaryKey": "id"
}

/** Frontend model for ModelSearchRule. */
export default class ModelSearchRule extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  isCollection() {
    return this.readAttributeUnderscore("is_collection")
  }

  /** @returns {boolean} */
  hasIsCollection() {
    const value = this.isCollection()

    return this._isPresent(value)
  }

  /** @returns {string} */
  modelSearchGroupId() {
    return this.readAttributeUnderscore("model_search_group_id")
  }

  /** @returns {boolean} */
  hasModelSearchGroupId() {
    const value = this.modelSearchGroupId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  relationshipPath() {
    return this.readAttributeUnderscore("relationship_path")
  }

  /** @returns {boolean} */
  hasRelationshipPath() {
    const value = this.relationshipPath()

    return this._isPresent(value)
  }

  /** @returns {any} */
  relationshipPathWithLabels() {
    return this.readAttributeUnderscore("relationship_path_with_labels")
  }

  /** @returns {boolean} */
  hasRelationshipPathWithLabels() {
    const value = this.relationshipPathWithLabels()

    return this._isPresent(value)
  }

  /** @returns {string} */
  ruleAttribute() {
    return this.readAttributeUnderscore("rule_attribute")
  }

  /** @returns {boolean} */
  hasRuleAttribute() {
    const value = this.ruleAttribute()

    return this._isPresent(value)
  }

  /** @returns {any} */
  ruleAttributeData() {
    return this.readAttributeUnderscore("rule_attribute_data")
  }

  /** @returns {boolean} */
  hasRuleAttributeData() {
    const value = this.ruleAttributeData()

    return this._isPresent(value)
  }

  /** @returns {string} */
  searchMatcher() {
    return this.readAttributeUnderscore("search_matcher")
  }

  /** @returns {boolean} */
  hasSearchMatcher() {
    const value = this.searchMatcher()

    return this._isPresent(value)
  }

  /** @returns {Record<string, any> | Array<any> | null} */
  searchValue() {
    return this.readAttributeUnderscore("search_value")
  }

  /** @returns {boolean} */
  hasSearchValue() {
    const value = this.searchValue()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static scanRelationship(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "scan_relationship",
        collectionName: "model_search_rules",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("./model-search-group.js").default | null} */
  modelSearchGroup() {
    return this._readBelongsToReflection({modelClass: ModelSearchGroup, reflectionName: "model_search_group"})
  }

  /** @returns {Promise<import("./model-search-group.js").default | null>} */
  loadModelSearchGroup() {
    if (!("modelSearchGroupId" in this)) throw new Error("Foreign key method wasn't defined: modelSearchGroupId")

    const id = this.modelSearchGroupId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "model_search_group",
        model: this,
        modelClass: ModelSearchGroup
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./model-search-group.js").default | null>} */
  ensureModelSearchGroupLoaded() {
    return this.ensureAssociationLoaded("model_search_group")
  }
}
